const PLAYER_ID_HEX_RE = /^dc-([a-f0-9]{16})$/i;

export function playerIdHexSuffix(playerId, length = 7) {
  const match = String(playerId || '').match(PLAYER_ID_HEX_RE);
  if (!match) {
    return null;
  }
  return match[1].slice(0, length).toLowerCase();
}

export function formatDisplayName(nickname, playerId) {
  const label = String(nickname || '').trim() || 'Player';
  const suffix = playerIdHexSuffix(playerId);
  return suffix ? `${label} (${suffix})` : label;
}
